import { render, staticRenderFns } from "./QuestionsList.vue?vue&type=template&id=5181cff0&scoped=true&"
import script from "./QuestionsList.vue?vue&type=script&lang=js&"
export * from "./QuestionsList.vue?vue&type=script&lang=js&"
import style0 from "./QuestionsList.vue?vue&type=style&index=0&id=5181cff0&lang=scss&scoped=true&"
import style1 from "./QuestionsList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5181cff0",
  null
  
)

export default component.exports